import { find, get, isEmpty, noop, size } from 'lodash'
import DetailSection from './components/DetailSection/DetailSection'
import TimeActionHeroPanel from './components/TimeActionHeroPanel/TimeActionHeroPanel'
import './TimeAndAction.style.less'
import { useEffect, useState } from 'react'
import { AllCommentDialog } from './components/AllCommentDialog/AllCommentDialog'
import AllDocumentDialog from './components/AllDocumentDialog/AllDocumentDialog'
import { Button, Row, Tabs, message } from 'antd'
import WorkFlowForm from './components/WorkFlowForm/WorkFlowForm'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { getUrlParams, isEmptyValue } from '@/utils/common'
import { useMutation, useQuery } from 'react-query'
import {
  createTimeActionTemplate,
  createTimeAndAction,
  getOrderOverView,
  updateCollaborator,
  updateTimeActionTemplate,
  updateTimeAndAction,
} from '../../../Order.transform'
import { useAuth } from '@/providers/auth.provider'
import { IsAdminRole } from '@/utils/users'
import { useNavigate } from 'react-router-dom'
import Gantt from '../Gantt'
import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator'
import {
  transformCollaborator,
  transformCollaboratorFromTemplate,
  transformTemplateForSave,
} from './TimeAction.helper'
import { queryClient } from '@/config/react-query'
import ModalTemplate from './components/ModalTemplate/ModalTemplate'
import ModalSaveTemplate from './components/ModalSaveTemplate/ModalSaveTemplate'
import PBFPermission from '@/screens/Order/components/PBFPermission'
import Fade from '@/components/Fade'
import { ITimeAndActionPayload } from '@/screens/Order/interface/order.interface'
import {
  COLLABORATOR_ROLE_EDITOR,
  COLLABORATOR_ROLE_OWNER,
} from '../../../Order.constant'
const { TabPane } = Tabs

interface Props {
  orderDetail: any
  collaborator: any
}

function TimeAndAction(props: Props) {
  const { orderDetail } = props
  const { user } = useAuth()
  const orderTimeActions = get(orderDetail, 'time_actions')
  const hasTimeActions = !!size(orderTimeActions)
  const [showAllCommentDialog, setShowAllCommentDialog] = useState(false)
  const [showAllDocumentDialog, setShowAllDocumentDialog] = useState(false)
  const [showWorkFlowCreation, setShowWorkFlowCreation] = useState(false)
  const [panelType, setpanelType] = useState('')
  const [isChecked, setisChecked] = useState(false)
  const [isEditWorkFlow, setisEditWorkFlow] = useState(false)
  const [activeSection, setActiveSection] = useState('')
  const orderId = getUrlParams('orderKey')
  const navigate = useNavigate()
  const isWorkspaceAdmin = IsAdminRole(user)

  const enableUserToCreate =
    isWorkspaceAdmin ||
    !!find(
      props.collaborator,
      (o) => o.user.id === user.id && o.roles.role === COLLABORATOR_ROLE_OWNER
    )

  useEffect(() => {
    const tmpPanelType = getUrlParams('panelType') ?? 'timeline'
    const sectionId = getUrlParams('sectionId') ?? data?.OrderSections[0]?.id
    setActiveSection(sectionId)
    setisChecked(tmpPanelType == 'tasks' ? true : false)
    setpanelType(tmpPanelType)
  }, [])

  const {
    data,
    isLoading,
    refetch: refetchOrderOverView,
  } = useQuery('ORDER_OVERVIEW', async () => {
    return await getOrderOverView(orderId)
  })
  const [sections, setsections] = useState([])
  const [templateId, setTemplateId] = useState(null)
  const [removedCollaborator, setremovedCollaborator] = useState([])
  const [collaborator, setCollaborator] = useState([])
  const [modalTemplate, setmodalTemplate] = useState(false)
  const [modalSaveTemplate, setModalSaveTemplate] = useState(false)
  const [isImport, setisImport] = useState(false)
  // const [isError, setisError] = useState(false)
  const [, contextHolder] = message.useMessage()

  const createTimeAndActionMutation = useMutation(async () => {
    const isCollaborator = props.collaborator.some(
      (item) => item.user.id == user.id
    )
    if (!isCollaborator) {
      await updateCollaborator(getUrlParams('orderKey'), [
        { ...user, role: COLLABORATOR_ROLE_OWNER, assignmentId: null },
      ])
    }
    const payload: ITimeAndActionPayload = {
      time_actions: {
        order_id: orderId,
        sections: sections,
      },
      collaborations: collaborator,
      template_id: templateId,
    }
    await createTimeAndAction(payload, user.id)
  })

  const updateTimeAndActionMutation = useMutation(async () => {
    const isCollaborator = props.collaborator.some(
      (item) => item.user.id == user.id
    )
    if (!isCollaborator) {
      await updateCollaborator(getUrlParams('orderKey'), [
        { ...user, role: COLLABORATOR_ROLE_OWNER, assignmentId: null },
      ])
    }
    const payload: ITimeAndActionPayload = {
      time_actions: {
        order_id: orderId,
        sections: sections,
      },
      collaborations: collaborator,
    }
    await updateTimeAndAction(
      payload,
      user.id,
      props.orderDetail?.time_actions[0]?.id
    )
  })

  const createTimeActionTemplateMutation = useMutation(async (data: any) => {
    const payload = transformTemplateForSave(
      data,
      orderId,
      sections,
      collaborator
    )
    if (!isEmptyValue(data.existingTemplate)) {
      await updateTimeActionTemplate(data.existingTemplate.id, payload)
    } else {
      await createTimeActionTemplate(payload)
    }
  })

  const onSwitchPanel = (value) => {
    const activeTab = getUrlParams('activeTab')
    if (!value) {
      navigate(
        `?orderKey=${orderId}&activeTab=${activeTab}&panelType=timeline`,
        {
          replace: true,
        }
      )
      setpanelType('timeline')
      setisChecked(false)
    } else {
      navigate(`?orderKey=${orderId}&activeTab=${activeTab}&panelType=tasks`, {
        replace: true,
      })
      setpanelType('tasks')
      setisChecked(true)
    }
  }

  const onClickTimeline = (id) => {
    const activeTab = getUrlParams('activeTab')
    navigate(
      `?orderKey=${orderId}&activeTab=${activeTab}&panelType=tasks&sectionId=${id}`,
      {
        replace: true,
      }
    )
    setpanelType('tasks')
    setActiveSection(id)
    setisChecked(true)
  }

  const onCloseTasks = () => {
    const activeTab = getUrlParams('activeTab')
    navigate(`?orderKey=${orderId}&activeTab=${activeTab}&panelType=timeline`, {
      replace: true,
    })
    setpanelType('timeline')
    setisChecked(false)
  }

  const onDetailSectionChange = (sectionId: string) => {
    const activeTab = getUrlParams('activeTab')
    navigate(
      `?orderKey=${orderId}&activeTab=${activeTab}&panelType=tasks&sectionId=${sectionId}`,
      {
        replace: true,
      }
    )
    setActiveSection(sectionId)
  }

  const AdminIsCollaborator = () => {
    return props.collaborator.some((item) => item.user.id == user.id)
  }

  const onEditWorkFlow = () => {
    setsections(data.OrderSections)
    setCollaborator(
      transformCollaborator(props.collaborator, user, props.orderDetail)
    )
    setisEditWorkFlow(true)
  }

  const onUpdateWorkFlow = async () => {
    let checkSectionError = false
    sections.forEach((item) => {
      if (isEmpty(item.name)) checkSectionError = true
    })
    if (checkSectionError) {
      message.error('Section Name is required!')
      checkSectionError = false
    } else {
      await updateTimeAndActionMutation.mutateAsync()
      await refetchOrderOverView()
      await queryClient.refetchQueries('ORDER_DETAIL')
      setsections([])
      setisEditWorkFlow(false)
    }
  }

  const onCreateWorkFlow = async () => {
    let checkSectionError = false
    sections.forEach((item) => {
      if (isEmpty(item.name)) checkSectionError = true
    })
    if (checkSectionError) {
      message.error('Section Name is required!')
      checkSectionError = false
    } else {
      if (props.orderDetail?.time_actions[0]?.id) {
        await onUpdateWorkFlow()
      }
      await createTimeAndActionMutation.mutateAsync()
      await refetchOrderOverView()
      await queryClient.refetchQueries('ORDER_DETAIL')
      setsections([])
      setShowWorkFlowCreation(false)
      setCollaborator([])
    }
  }

  const onCloseUpdateWorkFlow = () => {
    setCollaborator([])
    setsections([])
    setisEditWorkFlow(false)
  }

  const onShowWorkFlowCreation = () => {
    setShowWorkFlowCreation(true)
    setCollaborator(
      transformCollaborator(props.collaborator, user, props.orderDetail)
    )
  }

  const onCloseWorkFlowCreation = () => {
    setShowWorkFlowCreation(false)
    setCollaborator(props.collaborator)
    setsections([])
  }

  const onOpenModalTemplate = () => {
    setmodalTemplate(true)
  }

  const onCloseModalTemplate = () => {
    setmodalTemplate(false)
  }

  const onOpenModalSaveTemplate = () => {
    setModalSaveTemplate(true)
  }

  const onCloseModalSaveTemplate = () => {
    setModalSaveTemplate(false)
  }

  const onSaveTemplate = async (value) => {
    await createTimeActionTemplateMutation.mutateAsync({
      name: value.name,
      existingTemplate: !isEmptyValue(value.templates)
        ? JSON?.parse(value.templates)
        : null,
    })
    setModalSaveTemplate(false)
  }

  const onApplyTemplate = (val) => {
    setisImport(!isImport)
    setsections([...val.time_actions.sections])
    setTemplateId(val.template_id)
    setCollaborator(
      transformCollaboratorFromTemplate(val.collaborations, props.collaborator)
    )
    setmodalTemplate(false)
  }

  // START RENDER COMPONENT

  const handleRenderSetupWorkflow = () => {
    return (
      <div className="workflow-collab-container">
        <Tabs
          defaultActiveKey="1"
          tabBarExtraContent={
            <Row align={'middle'} style={{ marginBottom: 10 }}>
              <Button
                onClick={onOpenModalTemplate}
                className="use-template-button"
                size="large"
              >
                Use template
              </Button>
              <Button
                onClick={onCloseWorkFlowCreation}
                type="text"
                icon={<CloseOutlined />}
              />
            </Row>
          }
        >
          <TabPane tab="Workflow" key="1">
            <WorkFlowForm
              setSection={setsections}
              sections={sections}
              isImport={isImport}
            />
          </TabPane>
        </Tabs>
        <Row justify={'end'}>
          <Button
            onClick={onCloseWorkFlowCreation}
            className="cancel-button"
            type="dashed"
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={onOpenModalSaveTemplate}
            className="save-template-button"
            size="large"
          >
            Save As Template
          </Button>
          <Button onClick={onCreateWorkFlow} type="primary" size="large">
            Save
          </Button>
        </Row>
      </div>
    )
  }

  const handleRenderCreateNewWorkFlow = () => {
    if (enableUserToCreate) {
      if (showWorkFlowCreation) {
        return handleRenderSetupWorkflow()
      }
      return (
        <div className="create-time-action-placeholder-container">
          <p className="label">Create a Time & Action</p>
          <Button type="primary" size="large" onClick={onShowWorkFlowCreation}>
            <PlusOutlined />
            Set Workflow
          </Button>
        </div>
      )
    } else {
      return (
        <div className="create-time-action-placeholder-container">
          <p className="label">No Time & Action yet</p>
          <p className="description">
            The workflow will appear here once set up by the creator.
          </p>
        </div>
      )
    }
  }

  const handleRenderTimeActionSections = () => {
    return (
      <>
        <TimeActionHeroPanel
          onShowAllComment={() => setShowAllCommentDialog(true)}
          onShowAllDialog={() => setShowAllDocumentDialog(true)}
          data={data.orderHero}
          isCheck={isChecked}
          onSwitch={onSwitchPanel}
          collaborator={props.collaborator}
          activeSection={activeSection}
          onSectionChange={onDetailSectionChange}
          onEditWorkFlow={onEditWorkFlow}
        />
        {panelType == 'tasks' ? (
          <div className="plan-task-container">
            <DetailSection
              sectionData={data.OrderSections}
              refetch={noop}
              onCloseTask={onCloseTasks}
              sectionLoading={false}
              sectionError={false}
              activeSection={activeSection}
              onCurrentOrderSectionChange={onDetailSectionChange}
            />
          </div>
        ) : (
          <div className="gantt-container">
            <Gantt id={orderId} onClickTimeline={onClickTimeline} />
          </div>
        )}

        {showAllCommentDialog && (
          <AllCommentDialog
            onCancel={() => setShowAllCommentDialog(false)}
            visible={showAllCommentDialog}
          />
        )}

        {showAllDocumentDialog && (
          <AllDocumentDialog
            onClose={() => setShowAllDocumentDialog(false)}
            visible={showAllDocumentDialog}
          />
        )}
      </>
    )
  }
  // END RENDER COMPONENT

  if (
    isLoading ||
    updateTimeAndActionMutation.isLoading ||
    createTimeAndActionMutation.isLoading
  )
    return <LoadingIndicator loading={true} />

  if (isEditWorkFlow)
    return (
      <div className="time-action-container">
        <div className="workflow-collab-container">
          {contextHolder}
          <Tabs
            defaultActiveKey="1"
            tabBarExtraContent={
              <Button
                onClick={onCloseUpdateWorkFlow}
                type="text"
                icon={<CloseOutlined />}
              />
            }
          >
            <TabPane tab="Workflow" key="1" forceRender>
              <WorkFlowForm
                setSection={setsections}
                sections={sections}
                isImport={isImport}
              />
            </TabPane>
          </Tabs>
          <Row justify={'end'}>
            <Button
              onClick={onCloseUpdateWorkFlow}
              className="cancel-button"
              type="dashed"
              size="large"
            >
              Cancel
            </Button>
            <PBFPermission roles={[COLLABORATOR_ROLE_OWNER]}>
              <Button
                onClick={onOpenModalSaveTemplate}
                className="save-template-button"
                size="large"
              >
                Save As Template
              </Button>
            </PBFPermission>
            <Button onClick={onUpdateWorkFlow} type="primary" size="large">
              Update
            </Button>
          </Row>
        </div>
        {modalSaveTemplate && (
          <ModalSaveTemplate
            open={modalSaveTemplate}
            onSave={onSaveTemplate}
            onClose={onCloseModalSaveTemplate}
          />
        )}
      </div>
    )

  return (
    <Fade>
      <div className="time-action-container">
        {!hasTimeActions && handleRenderCreateNewWorkFlow()}
        {hasTimeActions && handleRenderTimeActionSections()}

        {modalTemplate && (
          <ModalTemplate
            onApply={onApplyTemplate}
            open={modalTemplate}
            onClose={onCloseModalTemplate}
          />
        )}

        {modalSaveTemplate && (
          <ModalSaveTemplate
            open={modalSaveTemplate}
            onSave={onSaveTemplate}
            onClose={onCloseModalSaveTemplate}
          />
        )}
      </div>
    </Fade>
  )
}

export default TimeAndAction
